export enum Regelstatus {
	Nieuw = 1,
	Werkbon = 2,
	Kalibratie =3,
	Reparatie = 4,
	Uitbesteed =5,
	Justeren = 6,
	Uitbesteed_Akkoord=7,
	// Validatie = 8,
	Publiceren = 9,
	Afkeur = 10,
	Gereed = 11,
	Verwerkt = 12,
	Afgehandeld = 13	
}